import type { ButtonTextColorMode } from '../types';
import * as styles from './SolidButton.styles';

const getCustomHoverStyle = (textColorMode: ButtonTextColorMode) =>
  textColorMode === 'dark' ? styles.hoverDarkTextModeFilter : styles.hoverLightTextModeFilter;

export const getHoverStyle = (textColorMode: ButtonTextColorMode, customBackgroundColor?: string) =>
  customBackgroundColor ? getCustomHoverStyle(textColorMode) : styles.hoverStandard;

export const getCustomBackgroundStyle = (customBackgroundColor?: string) =>
  customBackgroundColor ? { backgroundColor: customBackgroundColor } : {};
